import React from "react";
import { useTranslation } from "react-i18next";
import { formatMoney } from "@/utils/generalUtilities";

interface ServiceChargeInfoProps {
  serviceChargeAmount: number;
  serviceChargePaidBy: string;
}

const ServiceChargeInfo: React.FC<ServiceChargeInfoProps> = ({
  serviceChargeAmount,
  serviceChargePaidBy,
}) => {
  const { t } = useTranslation();

  const employerPays = serviceChargePaidBy === "Employer";
  const displayAmount = employerPays ? 0 : serviceChargeAmount;
  const helperText = employerPays
    ? t("onboarding.contributions.service_charge.employer_pays_helper")
    : t("onboarding.contributions.service_charge.employee_pays_helper");

  return (
    <div className="text-[18px] shadow-introBox font-outfit bg-white w-full rounded-[16px] mt-[16px]">
      <div className="px-[16px] py-[24px] md:p-[32px]">
        <div className="flex justify-between items-center mb-[12px]">
          <p className="font-semibold">
            {t("onboarding.contributions.service_charge.title")}
          </p>
          <p className="font-semibold text-[18px]">
            ${formatMoney(displayAmount)}
          </p>
        </div>
        <p className="text-[#8B8B8B] text-[16px] leading-[140%] mb-[16px]">
          {helperText}
        </p>
        <p className="text-[14px] text-[#8B8B8B] leading-[140%] italic border-t border-[#E2E2E2] pt-[16px]">
          {t("onboarding.contributions.service_charge.disclosure")}
        </p>
      </div>
    </div>
  );
};

export default ServiceChargeInfo;
